var map = {
	"./Angry.svg": "fe45",
	"./Haha.svg": "b47a",
	"./Like.svg": "79df",
	"./Love.svg": "3d9c",
	"./Sad.svg": "ec8f",
	"./Wow.svg": "968e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8305";